import { useState } from "react";
import style from "./style.module.css";

const Accordion = ({
  title,
  icon,
  defaultOpen = false,
  children,
  badge,
  // For "one open at a time" — pass openId, activeId, setActiveId
  openId,
  activeId,
  setActiveId,
}) => {
  // If solo-mode props are passed, use them; otherwise use local state
  const isSoloMode = openId !== undefined && activeId !== undefined && setActiveId !== undefined;
  const [localOpen, setLocalOpen] = useState(defaultOpen);

  const isOpen = isSoloMode ? activeId === openId : localOpen;

  const toggle = () => {
    if (isSoloMode) {
      setActiveId(activeId === openId ? null : openId);
    } else {
      setLocalOpen((o) => !o);
    }
  };

  return (
    <div className={style.accordion}>
      
      <div className={style.accordionHeader} onClick={toggle}>
        <div className={style.accordionHeaderLeft}>
          
          {icon && <span className={style.accordionIcon}>{icon}</span>}
          <span className={style.accordionTitle}>{title}</span>
          {badge !== undefined && (
            <span className={style.accordionBadge}>{badge}</span>
          )}
        </div>
        <img
          src={`${process.env.PUBLIC_URL}/close.png`}
          alt=""
          className={`${style.accordionChevron} ${isOpen ? style.open : ""}`}
        />
      </div>

      {isOpen && (
        <div className={style.accordionBody}>{children}</div>
      )}
    </div>
  );
};

export default Accordion;